import { render, staticRenderFns } from "./transcript.vue?vue&type=template&id=65f3e34a&scoped=true"
import script from "./transcript.vue?vue&type=script&lang=js"
export * from "./transcript.vue?vue&type=script&lang=js"
import style0 from "./transcript.vue?vue&type=style&index=0&id=65f3e34a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3e34a",
  null
  
)

export default component.exports